<template>
  <div>
    <v-toolbar
      id="main-header"
      flat
      color="#FAFAFA"
      class="header-toolbar"
      height="90"
    >
      <div style="margin-left: 3rem">
        <v-toolbar-side-icon class="hidden-md-and-up" @click="toggleDrawer" />
        <v-toolbar-title>
          <v-menu v-if="$store.state.bot.botId" offset-y class="">
            <template v-slot:activator="{ on }">
              <v-btn large class="" v-on="on">
                <v-avatar size="36px">
                  <img src="../../assets/logo.png" alt="Avatar" />
                </v-avatar>
                <b
                  :title="$store.state.bot.botTitle"
                  class="top-bot-name-tooltip-content"
                  >{{ $store.state.bot.botTitle }}</b
                >
              </v-btn>
            </template>
            <v-list>
              <v-list-tile
                v-if="$store.state.bot.botId"
                @click="$router.push('/publish')"
              >
                <v-list-tile-title>
                  Publish {{ $store.state.bot.botTitle }}
                </v-list-tile-title>
              </v-list-tile>
              <v-divider />
              <v-list-tile
                v-for="(bot, b) in $store.state.bot.allBots"
                :key="b"
                @click="selectBot(bot)"
              >
                <p>{{ bot.title }}</p>
              </v-list-tile>
            </v-list>
          </v-menu>
          <div v-if="showSaving" class="d-inline">
            <v-btn v-if="savingStatus" disabled class="savingStatus">
              Saving ...
            </v-btn>
            <v-btn v-else disabled class="savingStatus">
              <v-icon>done</v-icon>
              Saved
            </v-btn>
          </div>
        </v-toolbar-title>
      </div>
      <v-spacer />

      <!--      <cons-bar v-if="$store.state.settings.settings.licence_id && $route.path !== '/'"/>-->

      <v-spacer />
      <div class="rounded-card">
        <!-- <v-btn  large round color="primary" class="hidden-md-and-down" v-if="botId && $store.state.user.roleId !== 1" @click="openChat=true">
                <v-icon>comment</v-icon>
                Test Chatbot
            </v-btn> -->
        <v-btn
          v-if="
            $store.state.bot.botId &&
            $route.path === '/insights' &&
            $store.state.settings.settings.external_analytics
          "
          large
          outline
          color="primary"
          class="hidden-md-and-down"
          style="float: left"
          @click="$router.push('/custom-insights')"
        >
          <b class="">Custom Insights</b>
        </v-btn>
        <v-btn
          v-if="
            $store.state.bot.botId &&
            $route.path !== '/' &&
            $store.state.user.roleId === 1
          "
          large
          color="primary"
          class="hidden-md-and-down"
          style="float: left"
          @click="$router.push('/publish')"
        >
          <b class="">Publish</b>
        </v-btn>

        <v-menu offset-y class="user-avatar">
          <template v-slot:activator="{ on }">
            <v-btn round large flat class="pa-2" v-on="on">
              <!-- <v-avatar size="36px">
                <img
                  src="https://dashboard.botter.live/img/logo.8878de79.png"
                  alt="Avatar"
                />
              </v-avatar> -->
              {{ userData.first_name }} {{ userData.last_name }}
            </v-btn>
          </template>
          <v-list>
            <v-list-tile to="/profile">
              <v-icon>account_circle</v-icon>
              <v-list-tile-title class="px-2">Profile</v-list-tile-title>
            </v-list-tile>

            <v-list-tile @click="logout()">
              <v-icon>logout</v-icon>
              <v-list-tile-title class="px-2">Logout</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
      </div>
    </v-toolbar>
    <preview
      v-if="botId && openChat"
      :class="{ openChat: openChat }"
      @closeChat="openChat = false"
    />
  </div>
</template>

<script>
import settings from "../../data/settings";
import preview from "../test-chatbot/preview";
import common from '../../utils/common'
export default {
  components: {
    preview,
  },
  data() {
    return {
      openChat: false,
      usage: {},
      showSaving: false,
      settings: {},
    };
  },
  computed: {
    userData() {
      return this.$store.state.user.userData;
    },
    savingStatus() {
      return this.$store.state.core.savingStatus;
    },
    botId() {
      return this.$store.state.bot.botId;
    },
  },
  watch: {
    savingStatus() {
      this.showSaving = true;
      setTimeout(() => {
        this.showSaving = false;
      }, 4000);
    },
  },
  async mounted() {
    if (this.$store.state.bot.botId) {
      await this.getSettings();
    }
  },
  methods: {
    toggleDrawer() {
      this.$emit("toggleDrawer");
    },

    async getSettings() {
      const response = await this.$http_bot.get("/settings/");

      this.settings = response.data ? response.data : settings;
      this.$store.dispatch("setSettings", this.settings);
    },
    selectBot(bot) {
      const botId = bot.id;
      this.$store.dispatch("setBotId", botId);
      localStorage.setItem("botId", botId);
      this.$store.dispatch("setBotTitle", bot.title);
      localStorage.setItem("botTitle", bot.title);
      // this.$router.push(redirect);
      window.location.reload();
    },
    logout() {
      common.logOut();
    },
  },
};
</script>

<style lang="scss"></style>

<style scoped lang="scss">
.v-menu {
  display: inline-block;
}
.v-list {
  padding: 0;
}

@media only screen and (max-width: 1500px) {
  .top-bot-name-tooltip-content {
    font-size: 120%;
  }
}
@media only screen and (min-width: 1501px) {
  .top-bot-name-tooltip-content {
    font-size: 120%;
  }
}
</style>
